import { render, staticRenderFns } from "./officialTempMsg.vue?vue&type=template&id=16cd3879&scoped=true&"
import script from "./officialTempMsg.vue?vue&type=script&lang=js&"
export * from "./officialTempMsg.vue?vue&type=script&lang=js&"
import style0 from "./officialTempMsg.vue?vue&type=style&index=0&id=16cd3879&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd3879",
  null
  
)

component.options.__file = "officialTempMsg.vue"
export default component.exports